import type { BannerIconConfig } from "@/features/auth/types/organization.type";
import { useBannerConfig } from "@/features/theme";

/**
 * Returns the banner icon configuration for a given page key.
 * Re-exports useBannerConfig from the theme feature for backward compatibility.
 */
export const useBannerIcon = (pageKey?: string): BannerIconConfig | undefined => {
  return useBannerConfig(pageKey);
};
